/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://whitelabel.buildzone.net/live/graphql/";
const naturalDiamondListingApi = "diamondData";
const labDiamondListingApi = "diamondData";
const naturalDiamondDetailApi = "diamondById";
const labDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const naturalDiamondAddToCart = "diamondAddToCart";
const labDiamondAddToCart = "diamondAddToCart";
const productMetafield = "productMetafield";
const naturalRingAddToCart = "ringAddToCart";
const labRingAddToCart = "ringAddToCart";
const shopUrl = "https://shopify.transpacific-software.com";
// console.log("shopUrl",shopUrl)
const collectionHandel = "engagement-ring-settings";
// console.log(collectionHandel);
const diamondCollectionHandel = "diamonds";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Default Final Price Field Start ***/
function getDiamondDefaultFinalPriceField(currencyCode){
  var diamond_price_field;
	switch (currencyCode) {		
		case "EUR":
			diamond_price_field = "finalPriceEur";
			break;
		case "GBP":
			diamond_price_field = "finalPriceGbp";
			break;
		case "USD":
			diamond_price_field = "finalPriceUsd";
			break;		
		default:
			diamond_price_field = "finalPriceGbp"
	}
	return diamond_price_field;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currencyRate,finalPrice) {  
  var final_dia_price = finalPrice * currencyRate; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'natural-white' || type == 'natural-fancy'){
    dia_type = translations.titleNatural;
  }else{
    dia_type = translations.titleLabGrown;
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Name Start ***/
function getDiamondName(diamondData,diamondType) {
  var diamond_name = diamondData.caratWeight + "-Carat " + diamondData.shape + " Shape "+ diamondType +" Diamond ";
  return diamond_name;
}
/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  if(diamondData.measurement != ''){
    var measurements = diamondData.measurement;
  }else{
    var measurements = diamondData.length + " * " + diamondData.width + " * " + diamondData.depth;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != ''){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == ''){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == ''){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(diamondData) {  
  var diamondInformation = getDiamondInformationLayout(diamondData);
  
  var detailInfo = '';  
  detailInfo += '<div class="tps-product-details">';
  detailInfo += '<div class="tps-product-detail-section-heading" data-section="diamond-info"><h2>'+translations.titleDiamondDetails+'</h2><span class="tps-tab-arrow tps-arrow-down"></span></div>';
  detailInfo += '<div class="tps-product-details-info tps-product-details-diamond-info" style="display:none;">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);

  var diamond_ratio = diamondData.ratio;
   if(diamond_ratio == '0.0'){
     // var dia_ratio = '-';
     dia_ratio = diamondData.length/diamondData.width;
     dia_ratio = dia_ratio.toFixed(2);
   }else{
     dia_ratio = diamond_ratio;
   }

   var diamond_girdle = diamondData.girdle;
    if(diamond_girdle == null || diamond_girdle == undefined){
      // if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
      //   diamond_girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
      // }else{
      //   diamond_girdle = "-";
      // }   
  
      diamond_girdle = getDiamondGirdle(diamondData);
    }

  var diamond_intensity = diamondData.fancyColorIntensity;
  if(diamond_intensity == null || diamond_intensity == undefined) {
      diamond_intensity = "";
  }

  var diamond_overtone = diamondData.fancyColorOvertone;
  if(diamond_overtone == null || diamond_overtone == undefined) {
      diamond_overtone = "";
  }
  
  //Dynamic Diamond Information Array 
  var diamondInformation = {
    "diamondStockId" : translations.titleStockID+' - '+diamondData.stockNumber,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titleColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondRatio"   : translations.titleRatio+' - '+dia_ratio,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamond_girdle,
    "diamondCulet"   : translations.titleCulet+' - '+diamondData.culet,
    "diamondIntensity"  : translations.titleIntensity+' - '+diamond_intensity,
    "diamondOvartone"   : translations.titleOvertone+' - '+diamond_overtone,
  };
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         if(infoLable == 'Girdle'){
           if(diamondInfoArray.length == 3){
             var infoValue = diamondInfoArray[1]+' - '+diamondInfoArray[2];
           }else{
             var infoValue = "-";
           }           
         }else{
           var infoValue = diamondInfoArray[1];
         }
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3 && infoLable != 'Girdle'){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'de'){
  var tps_config = {
	"urls": {        
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/naturlicher-weisser-diamant",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "loose_diamond": "/pages/ringbuilder-natural-white-diamonds",
        "lab_diamond": "/pages/ringbuilder-lab-grown-white-diamonds",
        "loose_color_diamond": "/pages/ringbuilder-natural-color-diamonds", 
        "lab_color_diamond": "/pages/ringbuilder-lab-grown-color-diamonds",
        "loose_diamond_detail": "/pages/ringbuilder-diamond-details",
        "setting_listing": "/collections/engagement-ring-settings?metal=Platinum",
        "final_ring": "/pages/final-engagement-ring",
	}

  }
}
/*** End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

/*** Get Closest Number From Array ***/
function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}
/*** End ***/

/*** Get Array Index Value ***/  
function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
/*** End ***/

/*** Sort By Dropdown Open Close ***/
function sortByOpen() {
  if(jQuery('.tps-sort-dropdown-menu').css('display') !== 'none'){		
      sortByClose();
  }else {		
      jQuery('.tps-sort-dropdown-menu').css('display', 'block');

      if(jQuery(window).width() <= 824){
        jQuery('.tps-sort-dropdown-menu').addClass('tps-sort-dropdown-menu-show');
      }
  }
}
/*** End ***/

/*** Sort By Dropdown Close OnMouseLeave ***/
function sortByClose() {
  jQuery(".tps-sort-dropdown-menu").css('display', 'none');

  if(jQuery(window).width() <= 824){
    jQuery('.tps-sort-dropdown-menu').removeClass('tps-sort-dropdown-menu-show');
  }
}
/*** End ***/

/**** Mobile Filter Open/Close Start ****/ 
function mobileFilters(action){  
  if(action == 'open'){
    $(".tps-filter-container").addClass('tps-mobile-filters');
    $('body').addClass('tps-mobile-filters-open');
  }else{
    $(".tps-filter-container").removeClass('tps-mobile-filters');
    $('body').removeClass('tps-mobile-filters-open');
  }  
}
/*** End ***/

/*** Mobile Filter Close onClick Overly Start ***/
jQuery(document).on('click','.tps-mobile-filters',function(e){
  var container = $(".tps-filter-tabs-container");
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    mobileFilters('close');
  }
});
/*** Mobile Filter Close onClick Overly End ***/

/**** Mobile Filter Button Sticky Start ****/ 
$(window).scroll(function(){
    if ($(this).scrollTop() > 500) {
       $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
    } else {
       $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
    }
});
/*** End ***/

/*** Create & Update Session Filters Array Start ***/
function updateSessionFilters(arrayKey, filterKey, newValues) {
    // Retrieve the filters object from local storage or initialize an empty object
    let filters = JSON.parse(localStorage.getItem(arrayKey)) || {};

    // Split the newValues string by commas to handle multiple values
    let newValuesArray = newValues.split(',').map(value => value.trim());
 
    // Replace the old values with new ones
    filters[filterKey] = newValuesArray;
 
    // Save the updated filters object back to local storage
    localStorage.setItem(arrayKey, JSON.stringify(filters));
}
/*** Create & Update Session Filters Array End ***/

/*** Refine Your Results Focus To Filter Section ***/
function refineYourResults(){
  var target = '.tps-filter-container'; 
  $('html, body').animate({
        scrollTop: $(target).offset().top - 250
  }, 'slow'); 
}
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getURLParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Product Detail Info Open Close ***/
$(document).on("click", ".tps-product-detail-section-heading", function() {
  var data_section = jQuery(this).attr("data-section");
  if(jQuery(this).hasClass('active')){
    jQuery(".tps-product-detail-section-heading").removeClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-product-details-info').slideUp('slow');
  }else{
    jQuery('.tps-product-details-info').hide();
    jQuery(".tps-product-detail-section-heading").removeClass('active');
    jQuery(this).addClass('active');
    jQuery('.tps-tab-arrow').removeClass('tps-arrow-up').addClass('tps-arrow-down');
    jQuery(this).find('span').addClass('tps-arrow-up').removeClass('tps-arrow-down');    
    jQuery('.tps-product-details-'+data_section).slideDown('slow');
  }    
});
/*** End ***/

/*** Vertical Thumbnail Gallery Slick Slider Start ***/
function settingGalleryThumbnailSlider(verticalSlider){
  if(jQuery(window).width() <= 900){
    $('.tps-mobile-hide').remove();
    $('.tps_image_desk_banner').remove();
    var verticalSlider = false;
  }else{
    $('.tps-desktop-hide').remove();
    $('.tps_image_mob_banner').remove();
  }
  $('.tps-main-image-slide').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: true,
       arrows: false,       
       adaptiveHeight: true,
       asNavFor: '.tps-thumb-image-slide',
       draggable: false,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : true,
			        	adaptiveHeight  : true,			        	
                        infinity: true,
			      	}
			    },
		 	], 
   });

  if(verticalSlider == true){
     console.log("vetical slider ")
    $('.tps-thumb-image-slide').slick({
         vertical: true,
         verticalSwiping: true,
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true,
         asNavFor: '.tps-main-image-slide',        
         focusOnSelect: true,
         draggable: false, 
         arrows: true,
         lazyLoad: 'progressive',
     });
  }else{
    console.log("vetical slider 1")
    $('.tps-thumb-image-slide').slick({
       vertical: verticalSlider,
       verticalSwiping: true,
       slidesToShow: 5,
       slidesToScroll: 1,
       infinite: true,
       asNavFor: '.tps-main-image-slide',        
       focusOnSelect: true,
       draggable: false, 
       arrows: true,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,		
                        infinity: true,
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,	
                        infinity: true,
			      	}
			    },
		 	], 
    });
  }
}
/*** Vertical Thumbnail Gallery Slick Slider End ***/

/*** Get Formatted Metal Value For Image Alt Text Start ***/  
function getFromatedMetalValue(setting_metal){
  if(setting_metal.indexOf("18K ") >= 0){ 
     metal = setting_metal.replace('18K ','').trim();                 
  }else if(setting_metal.indexOf("14K ") >= 0){ 
     metal = setting_metal.replace('14K ','').trim();         
  }else{ 
     metal = setting_metal;
  }  
  return metal;
}
/*** Get Formatted Metal Value For Image Alt Text End ***/ 

/*** Get Final Ring Product Price Start ***/
function getFinalProductPrice(){
  var currency_rate = Shopify.currency.rate;
  
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_price;
  var diamond_price = diamond_info[0].diamond_price;
 
  var final_price = parseInt(setting_price)+parseInt(diamond_price);
  var final_converted_price = final_price * currency_rate;
    
  // final_price = getPriceWithCurrencySymbol(final_price);
  final_price = Shopify.formatMoney(final_converted_price * 100, theme.moneyFormat);
  return final_price;
}

function getPriceWithCurrencySymbol(price){
  price = Shopify.formatMoney(price*100,theme.moneyFormat);
  return price;
}
/*** Get Final Ring Product Price End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Mobile Step Icon Click Info Popup Start ***/
$(document).on("click", ".tps-step-icon", function(){
  // if(jQuery(window).width() <= 991){    
    var data_step = jQuery(this).attr("data-step");
      
    jQuery('.tps-step-product-info').removeClass('tps-step-product-info-show');
    jQuery('.tps-'+data_step+'-step-product-info').addClass('tps-step-product-info-show');
  // } 
});
/*** Mobile Step Icon Click Info Popup End ***/

/*** Product Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-step-product-info");
  var container2 = $(".tps-step-icon");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0){     
    jQuery(".tps-step-product-info").removeClass('tps-step-product-info-show');
  }
});
/*** Product Info Popoup Close Outer Click End ***/

/*** Check Devise Has Camera Or Not Start ***/
function checkCameraAvailability(){
  var availability = "No camera detected";
  navigator.mediaDevices?.enumerateDevices().then(devices => {
    const hasCamera = devices.some(device => device.kind === 'videoinput');
    if (hasCamera) {
      availability = "Camera available";      
    } else {
      availability = "No camera detected";
      jQuery(".tps-ring-try-on-section").hide();
    }
  }).catch(err => {
    alert("Camera check failed:", err);
  });
  return availability;
}
/*** Check Devise Has Camera Or Not End ***/

/*******
End
********/